// extracted by mini-css-extract-plugin
export var backdropBlur = "_ie-0";
export var contentCard = "_ie-5";
export var frame = "_ie-2";
export var image = "_ie-4";
export var imagePane = "_ie-3";
export var modal = "_ie-1";